import * as Types from '../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import { RequestAppointmentHeaderFragmentDoc } from './RequestAppointmentHeader.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestAppointmentPageMetadataQueryVariables = Types.Exact<{
  locationShortName: Types.Scalars['String']['input'];
}>;


export type RequestAppointmentPageMetadataQuery = { __typename?: 'Query', requestAppointmentPageMetadata: { __typename?: 'RequestAppointmentPageMetadata', email?: string | null, companyName: string, companyWebsite?: string | null, phoneNumber?: string | null, addressLine1?: string | null, addressLine2?: string | null, locality?: string | null, postalCode?: string | null, country?: string | null, logoUrl?: string | null } };


export const RequestAppointmentPageMetadataDocument = gql`
    query RequestAppointmentPageMetadata($locationShortName: String!) {
  requestAppointmentPageMetadata(locationShortName: $locationShortName) {
    ...RequestAppointmentHeader
  }
}
    ${RequestAppointmentHeaderFragmentDoc}`;

/**
 * __useRequestAppointmentPageMetadataQuery__
 *
 * To run a query within a React component, call `useRequestAppointmentPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestAppointmentPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestAppointmentPageMetadataQuery({
 *   variables: {
 *      locationShortName: // value for 'locationShortName'
 *   },
 * });
 */
export function useRequestAppointmentPageMetadataQuery(baseOptions: Apollo.QueryHookOptions<RequestAppointmentPageMetadataQuery, RequestAppointmentPageMetadataQueryVariables> & ({ variables: RequestAppointmentPageMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestAppointmentPageMetadataQuery, RequestAppointmentPageMetadataQueryVariables>(RequestAppointmentPageMetadataDocument, options);
      }
export function useRequestAppointmentPageMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestAppointmentPageMetadataQuery, RequestAppointmentPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestAppointmentPageMetadataQuery, RequestAppointmentPageMetadataQueryVariables>(RequestAppointmentPageMetadataDocument, options);
        }
export function useRequestAppointmentPageMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestAppointmentPageMetadataQuery, RequestAppointmentPageMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestAppointmentPageMetadataQuery, RequestAppointmentPageMetadataQueryVariables>(RequestAppointmentPageMetadataDocument, options);
        }
export type RequestAppointmentPageMetadataQueryHookResult = ReturnType<typeof useRequestAppointmentPageMetadataQuery>;
export type RequestAppointmentPageMetadataLazyQueryHookResult = ReturnType<typeof useRequestAppointmentPageMetadataLazyQuery>;
export type RequestAppointmentPageMetadataSuspenseQueryHookResult = ReturnType<typeof useRequestAppointmentPageMetadataSuspenseQuery>;
export type RequestAppointmentPageMetadataQueryResult = Apollo.QueryResult<RequestAppointmentPageMetadataQuery, RequestAppointmentPageMetadataQueryVariables>;